export const SIZE_LABELS = {
  mini_pilar: 'Mini con pilar',
  mini: 'Mini',
  pequeño_eco: 'Pequeño económico',
  pequeño: 'Pequeño',
  pequeño_plus: 'Pequeño Plus',
  mediano: 'Mediano',
  mediano_plus: 'Mediano Plus',
  grande: 'Grande',
  xl: 'XL',
};

export const SIZE_RANGES = [
  { key: 'mini_pilar', label: 'Mini con pilar', min: 0.80, max: 0.90, price: 40 },
  { key: 'mini', label: 'Mini', min: 0.91, max: 1.00, price: 45 },
  { key: 'pequeño_eco', label: 'Pequeño económico', min: 1.01, max: 1.50, price: 65 },
  { key: 'pequeño', label: 'Pequeño', min: 1.51, max: 1.70, price: 75 },
  { key: 'pequeño_plus', label: 'Pequeño Plus', min: 1.71, max: 2.00, price: 90 },
  { key: 'mediano', label: 'Mediano', min: 2.01, max: 2.50, price: 105 },
  { key: 'mediano_plus', label: 'Mediano Plus', min: 2.51, max: 3.00, price: 120 },
  { key: 'grande', label: 'Grande', min: 3.01, max: 3.60, price: 140 },
  { key: 'xl', label: 'XL', min: 3.61, max: 4.00, price: 155 },
];

export function getSizeCategory(m2) {
  const n = parseFloat(m2);
  if (isNaN(n)) return null;
  
  if (n <= 0.90) return 'mini_pilar';
  if (n <= 1.00) return 'mini';
  if (n <= 1.50) return 'pequeño_eco';
  if (n <= 1.70) return 'pequeño';
  if (n <= 2.00) return 'pequeño_plus';
  if (n <= 2.50) return 'mediano';
  if (n <= 3.00) return 'mediano_plus';
  if (n <= 3.60) return 'grande';
  
  return 'xl'; // Todo lo que exceda de 3.60 se cataloga como XL
}

export function getSizeCategoryLabel(m2) {
  const cat = getSizeCategory(m2);
  return cat ? SIZE_LABELS[cat] : `${m2} m²`;
}